import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import {
  getAllRolesRequest,
  putUserRolesRequest,
} from "../../../../../../Backend/AccountRequests";
import "./EditRolesModal.scss";

export function EditRolesModal({ user, submit, ...props }) {
  const [t] = useTranslation();
  const [userInfo, setUserInfo] = useState(user);
  const [allRoles, setAllRoles] = useState([]);
  const [roleDescriptionOpen, setRoleDescriptionOpen] = useState([]);

  useEffect(() => {
    getAllRoles();
  }, []);

  const getAllRoles = async () => {
    const resp = await getAllRolesRequest();

    if (resp.success) {
      setAllRoles(resp.data);
    }
  };

  const putUserRoles = async () => {
    const resp = await putUserRolesRequest(userInfo.id, userInfo.roleNames);

    if (resp.success) {
      submit();
      props.onHide();
    }
  };

  const toggleRoleDescriptionOpen = (i) => {
    setRoleDescriptionOpen(roleDescriptionOpen.includes(i) ? [] : [i]);
  };

  return (
    <Modal {...props} centered dialogClassName="edit-roles-modal">
      <Modal.Header closeButton />
      <Modal.Body className="edit-roles-modal-content">
        <div className="title">{t("EditRoles")}</div>
        <div className="subtitle">
          {userInfo.firstName}, {userInfo.lastName}
        </div>
        <div className="description">{t("YouCanOnlySelectOneRole")}</div>
        <div className="content-wrapper">
          <div className="role-list-wrapper">
            {allRoles.map((role, i) => {
              const isChecked = userInfo.roleNames.includes(role.name);
              return (
                <React.Fragment key={"role-" + role + "-" + i}>
                  <div
                    className={
                      role.cantBeSelected
                        ? "role-wrapper text-muted"
                        : "role-wrapper"
                    }
                  >
                    <div
                      className={
                        role.cantBeSelected ? "checkbox text-muted" : "checkbox"
                      }
                      onClick={() => {
                        if (!role.cantBeSelected) {
                          setUserInfo({ ...userInfo, roleNames: [role.name] });
                        }
                      }}
                    >
                      {isChecked ? "check_box" : "check_box_outline_blank"}
                    </div>
                    <div className="name">
                      {t(role.name) + " (" + role.name + ")"}
                    </div>
                    <div
                      className="icon"
                      onClick={() => toggleRoleDescriptionOpen(i)}
                    >
                      {roleDescriptionOpen.includes(i)
                        ? "help_outline"
                        : "help"}
                    </div>
                  </div>
                  {roleDescriptionOpen.includes(i) && (
                    <div
                      className="description-wrapper"
                      key={"description-role" + i}
                    >
                      {t(role.description)}
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
        <div className="button-wrapper">
          <Button className="button-cancel" onClick={() => props.onHide()}>
            {t("Cancel")}
          </Button>
          <Button className="button" onClick={() => putUserRoles()}>
            {t("SaveChanges")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
